import { render, staticRenderFns } from "./industryActivistyMaterial.vue?vue&type=template&id=5f8ef924&scoped=true"
import script from "./industryActivistyMaterial.vue?vue&type=script&lang=js"
export * from "./industryActivistyMaterial.vue?vue&type=script&lang=js"
import style0 from "./industryActivistyMaterial.vue?vue&type=style&index=0&id=5f8ef924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ef924",
  null
  
)

export default component.exports